import { makeAxiosRequest } from '@api/apiUtils';
import { makeDynamicApiRoute } from '@navigation/routes.utilities';

import { ApiUrls } from '../api.urls';

import type {
  CurrentUserFetchResponse,
  UserDescription,
} from '@api/users/api.users.types';

export const retrieveUser = (userId: string) => {
  const url = makeDynamicApiRoute(ApiUrls.users.retrieve, { id: userId });
  return makeAxiosRequest<UserDescription>({ url, method: 'get' });
};

export const retrieveActiveUser = () => {
  return makeAxiosRequest<CurrentUserFetchResponse>({
    url: ApiUrls.users.activeUser,
    method: 'get',
  });
};
